import { FormBase } from 'core/components';

export default class CloseOutPalletizingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouse',
					label: 'CLOSEOUTPALLETIZINGVIEW.WAREHOUSE',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/CloseOutPalletizingForm.js